document.addEventListener("DOMContentLoaded", function() {
    // Keep track of the previously clicked menu item
    var previousMenuItem = null;

    // Get all menu items
    var menuItems = document.querySelectorAll('span, .header__menu-item');

    // Add click event listener to each menu item
    menuItems.forEach(function(item) {
        item.addEventListener('click', function(event) {
            // Remove header__active-menu-item from all items
            menuItems.forEach(function(menuItem) {
                menuItem.classList.remove('header__active-menu-item');
            });

            // Add header__active-menu-item to the clicked item
            event.currentTarget.classList.add('header__active-menu-item');

            // Hide submenu of the previously clicked item
            if (previousMenuItem && previousMenuItem.nextElementSibling) {
                var previousSubmenu = previousMenuItem.nextElementSibling;
                if (previousSubmenu.classList.contains('header__submenu')) {
                    previousSubmenu.classList.remove('visible');
                }
            }

            // Show submenu for the clicked item
            var submenu = event.currentTarget.nextElementSibling;
            if (submenu && submenu.classList.contains('header__submenu')) {
                submenu.classList.add('visible');
            }

            // Update the previously clicked item
            previousMenuItem = event.currentTarget;
        });

        // Add 'visible' class to submenu of active menu item on page load
        if (item.classList.contains('header__active-menu-item')) {
            var submenu = item.nextElementSibling;
            if (submenu && submenu.classList.contains('header__submenu')) {
                submenu.classList.add('visible');
            }
        }
    });
});
